import React from "react";
import DatePicker from './DatePicker'
import TextInput from './TextInput'
import FixButton from './Button'
import moment from 'moment';
import SelectInput from "./SelectInput";
import translateString from "../utils/Locales";
import Utils from "../utils/utils";

let t = translateString;

export default class EditEsame extends React.Component {

    constructor (props){
        super(props);

        this.dateRef = React.createRef();
        this.selectRef = React.createRef();

    }

    async componentDidMount() {

        this.selectType = [
            { value: 1, label: t('prova_scritta') },
            { value: 2, label: t('prova_orale') }
        ];
    
        this.setState({
            visible: this.props.show,
            data: this.props.data,
            titoloEsame: this.props.titolo,
            type: this.props.tipo ? this.props.tipo : undefined,
        });

    }

    render (){

        if (!this.state) return <div />;
        let st = Object.assign({display: this.state.visible ? 'block' : 'none'}, mainClass);

        return ( 
        <div style={st} >
            <div style={container} onClick={() => { this.setState({visible: false}); this.props.onCancel(); }}>
                <div style={mainClass} onClick={(e) => e.stopPropagation()}>
                    <div style={closeIcon} onClick={() => {
                        this.setState({visible: false});
                        this.props.onCancel();
                    }}>
                        <img alt="" src={ require('../images/close_icon.png')} style={{ width: 30, height: 30, cursor: 'pointer' }} />
                    </div>
                    <div style={{marginTop: '10px'}}>
                        <div style={windowTitle}>{t('modifica_esame')}</div>
                        <div style={{ display: 'flex', marginLeft: 5, marginBottom: 0, marginTop: 0 }}>
                            <img alt="" src={ require('../images/question_icon.png') } style={{ width: 10, height: 10, marginRight: 5, marginTop: 1 }} />
                            <p style={{ fontSize: 10, color: 'darkgray', maxWidth: '80%' }}>{t('modifica_esame_info')}</p><br/>
                        </div>
                        <SelectInput key={Math.random()} 
                            ref={this.selectRef}
                            value={this.state.type} 
                            name={t('tipologia') + ' *'} 
                            options={this.selectType} 
                            onChange={(option) => {
                                this.setState({ type: { value: option.value, label: option.label } });
                            } 
                        } />
                        <br/>
                        <DatePicker ref={this.dateRef} name="" placeholder={t('data') + " *"} inputStyle={{ borderLeft: 0, borderTop: 0, borderRight: 0, borderBottom: '1px solid darkgrey', width: '290px' }} value={this.state.data} onChange={d => { alert (d);this.setState({data: d})}}/>
                        <TextInput name={''} placeholder={t('note')} style={{ borderLeft: 0, borderTop: 0, borderRight: 0, borderBottom: '1px solid darkgrey', width: '290px' }} value={this.state.titoloEsame} 
                            onChange={(text) => { this.setState({titoloEsame: text})} }
                        />
                        <br/>
                        <FixButton title={t('salva')} callback={this.okClicked.bind(this)} />
                    </div>
                </div>
            </div>
        </div>
        )
    }

    async okClicked(){
        
        if (this.state.type.value === undefined) {
            Utils.showInfo('Specifica il tipo di prova.');
            return;
        };
        
        const daDate = this.dateRef.current.getDate();
        let dataEsame = moment(daDate).format('yyyy-MM-DD');

        this.props.onOkClicked(this.state.type.value, dataEsame, this.state.titoloEsame);
    }
}

const windowTitle = {
    color: 'darkgrey', 
    fontSize: 30, 
    fontWeight: 'bold', 
    fontFamily: 'Teko', 
    textAlign:'left', 
    marginLeft: 5, 
}

const closeIcon = {
    position: 'absolute', 
    cursor: 'pointer',
    right: 10, 
    top: 10, 
    padding: 10, 
    zIndex: 999,
}

const container = {
    position: 'fixed', 
    display: 'block', 
    top: 0,
    left: 0, 
    bottom: 0, 
    right: 0,
    minWidth: '100%', 
    minHeight: '100%', 
    backgroundColor: '#3C3C3C4D',
    overflow: 'scroll',
};

const mainClass = {
    position: 'absolute',
    left: 'calc((100% - 350px)/2',
    top: '25%',
    right: '35%',
    minWidth: '350px',
    width: '350px',
    background: 'white',
    padding: '20px',
    zIndex: 999,
    boxShadow: '0px 2px 10px darkgrey', 
    borderRadius: '10px',
}
